<template>
    <b-td>
        <input
                :type="type"
                class="filterInputText"
                v-model="val"
                @input="sendToParent"
                :placeholder= placeholder
        />
    </b-td>
</template>

<script>
    export default {
        name: 'TableFilterInput',
        props:{
            placeholder: String,
            name: String,
            type: String
        },
        data(){
            return {
                val: ''
            };
        },
        methods:{
            sendToParent(){
                this.$emit('method', this.name ,this.val);
            }
        }
    };
</script>

<style scoped>
    @import '../../assets/style/css/base.css';
</style>
